import _classCallCheck from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/example/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { __rest } from "tslib";
import * as React from 'react';
import styles from '@patternfly/react-styles/css/components/OverflowMenu/overflow-menu';
import { css } from '@patternfly/react-styles';
import { OverflowMenuContext } from './OverflowMenuContext';
import mdBreakpoint from '@patternfly/react-tokens/dist/js/global_breakpoint_md';
import lgBreakpoint from '@patternfly/react-tokens/dist/js/global_breakpoint_lg';
import xlBreakpoint from '@patternfly/react-tokens/dist/js/global_breakpoint_xl';
import xl2Breakpoint from '@patternfly/react-tokens/dist/js/global_breakpoint_2xl';
import { debounce } from '../../helpers/util';
var breakpoints = {
  md: mdBreakpoint,
  lg: lgBreakpoint,
  xl: xlBreakpoint,
  '2xl': xl2Breakpoint
};
export var OverflowMenu =
/*#__PURE__*/
function (_React$Component) {
  _inherits(OverflowMenu, _React$Component);

  function OverflowMenu(props) {
    var _this;

    _classCallCheck(this, OverflowMenu);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(OverflowMenu).call(this, props));

    _this.handleResize = function () {
      var breakpointPx = breakpoints[_this.props.breakpoint];

      if (!breakpointPx) {
        // eslint-disable-next-line no-console
        console.error('OverflowMenu will not be visible without a valid breakpoint.');
        return;
      }

      var breakpointWidth = Number(breakpointPx.value.replace('px', ''));
      var isBelowBreakpoint = window.innerWidth < breakpointWidth;

      _this.setState({
        isBelowBreakpoint: isBelowBreakpoint
      });
    };

    _this.state = {
      isBelowBreakpoint: false
    };
    return _this;
  }

  _createClass(OverflowMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleResize();
      window.addEventListener('resize', debounce(this.handleResize, 250));
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', debounce(this.handleResize, 250));
    }
  }, {
    key: "render",
    value: function render() {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      var _a = this.props,
          className = _a.className,
          breakpoint = _a.breakpoint,
          children = _a.children,
          props = __rest(_a, ["className", "breakpoint", "children"]);

      return React.createElement("div", Object.assign({}, props, {
        className: css(styles.overflowMenu, className)
      }), React.createElement(OverflowMenuContext.Provider, {
        value: {
          isBelowBreakpoint: this.state.isBelowBreakpoint
        }
      }, children));
    }
  }]);

  return OverflowMenu;
}(React.Component);
OverflowMenu.contextType = OverflowMenuContext;